<script>
import { CheckCircleIcon } from "@heroicons/vue/outline";
export default {
    props: ["state", "approvalDate", "lastApprovedBy"],
    components: {
        CheckCircleIcon,
    },
};
</script>

<template>
    <div
        v-if="state === 'approved'"
        class="mt-4 flex items-start rounded space-x-3 p-3 bg-lime-100"
    >
        <CheckCircleIcon class="h-6 w-6 text-lime-600" />
        <p class="text-lime-800 font-semibold text-md">
            {{ $t("orderModifications.orderModificationApproved") }}
            <br />
            <span class="font-normal"
                >{{ $t("orderModifications.orderModificationApprovedDesc") }}
                {{ $t("orderModifications.by") }}
                {{ lastApprovedBy }}
                {{ $t("orderModifications.at") }}
                {{
                    new Date(approvalDate).toLocaleString("de-CH", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                    })
                }}
                {{ $t("orderModifications.oclock") }}.</span
            >
        </p>
    </div>
</template>

<style scoped></style>
